import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import ReferralLabel from 'marketing/ReferralLabel'
import TextButton from 'LuxKit/Button/TextButton'

const NON_PENDING_LOG_STATUS = ['redeemed', 'order_ineligible']

const Wrapper = styled.div`
  margin-top: ${rem(36)};

  & > * + * {
    box-shadow: ${props => `0px 1px 0px 0px ${props.theme.palette.neutral.default.six} inset`};
  }

  & .showOnHighWidth {
    display: none;
  }

  ${mediaQueryUp.tablet} {
    & .hiddenOnHighWidth {
      display: none;
    }

    & .showOnHighWidth {
      display: block;
    }
  }
`

const Row = styled.div`
  &.heading{
    display: none;
  }

  ${mediaQueryUp.tablet} {
    width: 100%;
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    align-items: center;

    &.heading{
      display: grid;
    }

    & > * {
      overflow: hidden;
    }
  }
`

const Cell = styled.div`
  padding: ${rem(8)};

  &.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .align-text{
    text-align: right;
  }

  & > .first-name-text {
    display: none;
  }

  & .pending-reward {
    display: none;
  }

  ${mediaQueryUp.tablet} {
    &.flex {
      display: block;

      > :first-child{
        display: none;
      }
    }

    & .align-text{
      text-align: left;
    }

    & > .first-name-text {
      display: block;
    }

    & > .first-name-heading {
      display: none;
    }
  }
`

interface Props {
  referralLogs: Array<App.ReferralLogItem>;
}

function ReferralGrid({ referralLogs }: Props) {
  return (
    <div>
      <Heading variant="heading3">
        Your reward activity
      </Heading>
      <Wrapper>
        <Row className="heading">
          <Cell>
            <Heading variant="heading6">
              Referral
            </Heading>
          </Cell>
          <Cell>
            <Heading variant="heading6">
              Status
            </Heading>
          </Cell>
          <Cell>
            <Heading variant="heading6">
              Reward
            </Heading>
          </Cell>
        </Row >
        {referralLogs.map((log, index) => <Row data-testid="referral-logs" key={`${log.first_name}${index}`}>
          <Cell>
            <BodyText variant="medium" weight="bold" className="first-name-text">{log.first_name}</BodyText>
            <Heading variant="heading6" className="first-name-heading">{log.first_name}</Heading>
          </Cell>
          <Cell className="flex">
            <BodyText variant="medium" weight="bold">Status</BodyText>
            <ReferralLabel referralLabel={log.log_status} />
          </Cell>
          <Cell className="flex">
            <BodyText variant="medium" weight="bold" className={cn({ 'pending-reward': log.log_status !== 'redeemed' })}>Reward</BodyText>
            {!NON_PENDING_LOG_STATUS.includes(log.log_status) && <TextButton kind="secondary" data-testid="pending-button" fit="full-width" disabled>Pending</TextButton>}
            {log.log_status === 'redeemed' && (
              <span>
                <BodyText data-testid="log-earn-amount" variant="medium" weight="bold" className="align-text">{log.earn_amount}</BodyText>
                <Caption variant="medium" className="align-text" colour="neutral-three">{log.earn_details}</Caption>
              </span>
            )}
          </Cell>
        </Row>)}
      </Wrapper>
    </div>
  )
}

export default ReferralGrid
